import React, {
  useEffect,
  useRef,
  useContext,
  useState,
  useMemo,
  useCallback,
} from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { ListItem, Checkbox } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CensusService from "_services/Census/CensusService";
import { DashboardContext } from "states/DashboardContext";
import Button from "@mui/material/Button";
import { Districts } from "./data/Districts";

// Cesnsus service
const censusService = CensusService();

const CensusAreaDropDown = () => {
  // Global state
  const {
    languageState,
    loadingState,
    censusVizDataState,
    censusVizNameState,
    censusAgeGroupState,
    censusSelectedAreasState,
  } = useContext(DashboardContext);
  const [language] = languageState;
  const [loading, setLoading] = loadingState;
  const [censusVizData, setCensusVizData] = censusVizDataState;
  const [censusAgeGroup, setCensusAgeGroup] = censusAgeGroupState;
  const [vizAreaName, setVizAreaName] = censusVizNameState;
  const [censusSelectedAreas, setCensusSelectedAreas] =
    censusSelectedAreasState;
  const [dataDown, setYourData] = useState(censusVizData);

  // component state
  const [openDropDown, setOpenDropDown] = useState(false);
  const [openNational, setOpenNational] = useState(0);
  const [openSubNational, setOpenSubNational] = useState(0);
  const [openRegion, setOpenRegion] = useState(0);
  const [openCouncil, setOpenCouncil] = useState(0);
  const [openConstituent, setOpenConstituent] = useState(0);
  const [openWard, setOpenWard] = useState(0);
  const dropdownRef = useRef(null);

  // keep track the selected all level
  const [selectAll, setSelectAll] = useState({
    region: {},
    council: {},
    ward: {},
  });

  //   Area  names
  const [areaName, setAreaName] = useState("Tanzania");

  //National
  const [National, setNational] = useState([]);

  //Sub National
  const [subNational, setSubNational] = useState([]);
  // Region
  const [Region, setRegion] = useState([]);

  // Council
  const [Disctrict, setDisctrict] = useState([]);
  // Council
  const [Council, setCouncil] = useState([]);

  // Constituents
  const [Constituent, SetConstituent] = useState([]);

  // wards
  const [Ward, setWard] = useState([]);

  // Fetch Areas from API
  useEffect(() => {
    if (Region.length === 0) {
      const fetchAreaData = async () => {
        const data = await censusService.getAreas();
        setNational(
          data
            .filter((item) => item.area_level === "LVL1")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );
        setSubNational(
          data
            .filter((item) => item.area_level === "LVL2")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );
        setRegion(
          data
            .filter((item) => item.area_level === "LVL3")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );
        setDisctrict(
          data
            .filter((item) => item.area_level === "LVL4")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );

        setCouncil(
          data
            .filter((item) => item.area_level === "LVL5")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );

        SetConstituent(
          data
            .filter((item) => item.area_level === "LVL6")
            .sort((a, b) => {
              return a.area_name.localeCompare(b.area_name);
            })
        );
        const newData = data
          .filter((item) => item.area_level === "LVL7")
          .map((item) => {
            const constObject = data.find(
              (constObj) =>
                constObj.area_level === "LVL6" &&
                constObj.area_code === item.parent_code
            );
            if (constObject) {
              const councilObject = data.find(
                (councilObj) =>
                  councilObj.area_level === "LVL5" &&
                  councilObj.area_code === constObject.parent_code
              );
              if (councilObject) {
                return {
                  ...item,
                  grandpa_code: councilObject.area_code,
                };
              }
            }
            return item;
          })
          .sort((a, b) => {
            return a.area_name.localeCompare(b.area_name);
          });

        setWard(newData);
      };

      fetchAreaData();
    }
  }, []);

  const handleOpenDropDown = () => {
    setOpenDropDown(!openDropDown);
  };

  const handleClickNational = (id) => {
    if ((openNational !== id) | (openNational === 0)) {
      setOpenNational(id);
      setOpenSubNational(0);
      setOpenRegion(0);
    } else {
      setOpenNational(0);
    }
  };

  // when SubNational clicked
  const handleClickSubNational = (id) => {
    if ((openSubNational !== id) | (openSubNational === 0)) {
      setOpenSubNational(id);
      setOpenRegion(0);
    } else {
      setOpenSubNational(0);
    }
  };

  // when Region clicked
  const handleClickRegion = (id, Region) => {
    if ((openRegion !== id) | (openRegion === 0)) {
      setOpenRegion(id);
      // Reset council
      setOpenCouncil(0);
    } else {
      setOpenRegion(0);
    }
  };

  // When council clicked
  const handleClickCouncil = (id, Areaname) => {
    if ((openCouncil !== id) | (openCouncil === 0)) {
      setOpenCouncil(id);
      setOpenConstituent(0);
    } else {
      setOpenCouncil(0);
    }
  };

  const toggleAreaSelection = useCallback((item) => {
    setCensusSelectedAreas((prev) => {
      const exists = prev.some((area) => area.area_name === item.area_name);
      return exists
        ? prev.filter((area) => area.area_name !== item.area_name)
        : [...prev, item];
    });
  }, []);

  const selectedAreaNames = useMemo(() => {
    return new Set(censusSelectedAreas.map((area) => area.area_name));
  }, [censusSelectedAreas]);

  const handleToggleSelection = useCallback(
    (item) => {
      toggleAreaSelection(item);
    },
    [toggleAreaSelection]
  );

  const getFilteredCouncils = (districts, councils, openRegion) => {
    return councils.filter((council) =>
      districts.some(
        (district) =>
          district.parent_code === openRegion &&
          district.area_code === council.parent_code
      )
    );
  };

  const getFilteredCouncilsToSelect = (districts, councils, openRegion) => {
    // Step 1: Find all districts that belong to the openRegion
    const relatedDistricts = districts.filter(
      (district) => district.parent_code === openRegion
    );

    // Step 2: Find all councils that belong to those districts
    return councils.filter((council) =>
      relatedDistricts.some(
        (district) => district.area_code === council.parent_code
      )
    );
  };

  //function to handle the select all level
  const handleSelectAll = (level, parentCode, items) => {
    setCensusSelectedAreas((prevSelected) => {
      const selectedSet = new Set(prevSelected.map((area) => area.area_name));

      // Filter items based on level (region, council, ward)
      const filteredItems =
        level === "ward"
          ? items.filter((item) =>
              Ward.some(
                (ward) =>
                  ward.area_code === item.area_code &&
                  belongsToParent(ward.parent_code, parentCode)
              )
            )
          : level === "council"
          ? items.filter((item) =>
              getFilteredCouncils(Disctrict, Council, parentCode).some(
                (council) => council.area_code === item.area_code
              )
            )
          : items.filter((item) => item.parent_code === parentCode);

      // Check if all councils/wards under this region/council are selected
      const allSelected = filteredItems.every((item) =>
        selectedSet.has(item.area_name)
      );

      if (allSelected) {
        // If all are selected, deselect them
        return prevSelected.filter(
          (area) =>
            !filteredItems.some((item) => area.area_name === item.area_name)
        );
      } else {
        // Otherwise, select them all
        const newSelections = filteredItems.filter(
          (item) => !selectedSet.has(item.area_name)
        );
        return [...prevSelected, ...newSelections];
      }
    });

    // Update "Select All" state
    setSelectAll((prev) => ({
      ...prev,
      [level]: {
        ...prev[level],
        [parentCode]: !selectAll[level]?.[parentCode],
      },
    }));
  };

  const belongsToParent = (wardParentCode, councilAreaCode) => {
    return wardParentCode.startsWith(councilAreaCode);
  };

  //handle close when click outside collapse
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropDown(false);
      }
    };

    if (openDropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropDown]);

  //Implementing Highlight the selected areas w.r.t their parents
  const areaMap = useMemo(() => {
    const all = [
      ...National,
      ...subNational,
      ...Region,
      ...Disctrict,
      ...Council,
      ...Constituent,
      ...Ward,
    ];
    const m = {};
    all.forEach((item) => {
      m[item.area_code] = item;
    });
    return m;
  }, [National, subNational, Region, Disctrict, Council, Constituent, Ward]);

  const hasDescendantSelected = useCallback(
    (parentCode) => {
      return censusSelectedAreas.some((selected) => {
        // start from the leaf
        let code = selected.area_code;
        // climb up until you hit the root
        while (code && areaMap[code] && areaMap[code].parent_code) {
          if (areaMap[code].parent_code === parentCode) {
            return true;
          }
          code = areaMap[code].parent_code;
        }
        return false;
      });
    },
    [censusSelectedAreas, areaMap]
  );

  return (
    <div
      className="flex flex-col"
      style={{ position: "relative", overflow: "visible", zIndex: 999 }}
    >
      <div className="flex flex-row items-center gap-2">
        <Button
          onClick={handleOpenDropDown}
          sx={{
            backgroundColor: "#fff",
            color: "black",
            paddingTop: 0,
            paddingBottom: 0,
            textTransform: "none",
            border: "1px solid #ddd",
            boxShadow: "none",
            borderRadius: "6px",
            display: "flex",
            paddingRight: "44px",
            alignItems: "center",
            gap: "6px",
          }}
          variant="contained"
        >
          <AddIcon fontSize="small" className="text-sm" />
          Select Areas
        </Button>
      </div>
      <Collapse
        in={openDropDown === true}
        timeout="auto"
        unmountOnExit
        style={{
          position: "fixed", // Fixed to center in viewport
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centering trick
          zIndex: 1000,
          overflowY: "auto",
          width: "900px",
          height: "500px", // Optional: so it doesn’t overflow screen
          padding: "20px",
          backgroundColor: "white",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.35)",
          borderRadius: "8px", // Optional: make it look nice
        }}
      >
        <div ref={dropdownRef}>
          <div className="flex justify-end p-0">
            <Button
              style={{ textTransform: "none" }}
              size="small"
              variant="outlined"
              onClick={handleOpenDropDown}
            >
              Save
            </Button>
          </div>
          <div
            style={{
              height: "400px", // Fixed height
              overflowY: "auto", // Enable vertical scrolling
              padding: "10px",
            }}
          >
            <List component="nav">
              {National.map((item) => (
                <ListItem
                  key={item.area_code}
                  value={item.area_code}
                  disablePadding
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "start",
                  }}
                >
                  <div className="flex flex-row items-center">
                    {openNational === item.area_code ? (
                      <RemoveIcon
                        className="border mr-1"
                        fontSize="small"
                        onClick={() => handleClickNational(item.area_code)}
                      />
                    ) : (
                      <AddIcon
                        className="border mr-1"
                        fontSize="small"
                        onClick={() => handleClickNational(item.area_code)}
                      />
                    )}
                    <Checkbox
                      checked={selectedAreaNames.has(item.area_name)}
                      onChange={() => handleToggleSelection(item)}
                    />
                    <ListItemButton
                      sx={{
                        pl: 2,
                        bgcolor: selectedAreaNames.has(item.area_name)
                          ? "rgba(0,200,0,0.1)"
                          : hasDescendantSelected(item.area_code)
                          ? "rgba(0,0,0,0.05)"
                          : "inherit",
                      }}
                      dense={true}
                    >
                      <ListItemText primary={item.area_name} />
                    </ListItemButton>
                  </div>
                  {/* Sub National */}
                  <Collapse
                    in={openNational === item.area_code}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div">
                      {subNational.map(
                        (item) =>
                          openNational === item.parent_code && (
                            <ListItem
                              key={item.area_code}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "start",
                              }}
                            >
                              <div className="flex flex-row items-center">
                                {openSubNational === item.area_code ? (
                                  <RemoveIcon
                                    className="border mr-1"
                                    fontSize="small"
                                    onClick={() =>
                                      handleClickSubNational(item.area_code)
                                    }
                                  />
                                ) : (
                                  <AddIcon
                                    className="border mr-1"
                                    fontSize="small"
                                    onClick={() =>
                                      handleClickSubNational(item.area_code)
                                    }
                                  />
                                )}
                                <Checkbox
                                  checked={selectedAreaNames.has(
                                    item.area_name
                                  )}
                                  onChange={() => handleToggleSelection(item)}
                                />

                                <ListItemButton
                                  sx={{
                                    pl: 2,
                                    bgcolor: selectedAreaNames.has(
                                      item.area_name
                                    )
                                      ? "rgba(0,200,0,0.1)"
                                      : hasDescendantSelected(item.area_code)
                                      ? "rgba(0,0,0,0.05)"
                                      : "inherit",
                                  }}
                                  dense={true}
                                >
                                  <ListItemText primary={item.area_name} />
                                </ListItemButton>
                              </div>
                              {/* Region */}
                              <Collapse
                                in={openSubNational === item.area_code}
                                timeout="auto"
                                unmountOnExit
                              >
                                <div className="flex flex-row font-bold items-center ml-10">
                                  <Checkbox
                                    checked={Region.filter(
                                      (reg) =>
                                        reg.parent_code === item.area_code
                                    ).every((reg) =>
                                      selectedAreaNames.has(reg.area_name)
                                    )}
                                    onChange={() =>
                                      handleSelectAll(
                                        "region",
                                        item.area_code,
                                        Region.filter(
                                          (reg) =>
                                            reg.parent_code === item.area_code
                                        )
                                      )
                                    }
                                  />
                                  <span>Select All Regions</span>
                                </div>
                                <List component="div">
                                  {Region.map(
                                    (item) =>
                                      // display only required values
                                      openSubNational === item.parent_code && (
                                        <ListItem
                                          key={item.area_code}
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "start",
                                            alignItems: "start",
                                          }}
                                        >
                                          <div className="flex flex-row items-center">
                                            {openRegion === item.area_code ? (
                                              <RemoveIcon
                                                className="border mr-1"
                                                fontSize="small"
                                                onClick={() =>
                                                  handleClickRegion(
                                                    item.area_code,
                                                    item.area_name
                                                  )
                                                }
                                              />
                                            ) : (
                                              <AddIcon
                                                className="border mr-1"
                                                fontSize="small"
                                                onClick={() =>
                                                  handleClickRegion(
                                                    item.area_code,
                                                    item.area_name
                                                  )
                                                }
                                              />
                                            )}
                                            <Checkbox
                                              checked={selectedAreaNames.has(
                                                item.area_name
                                              )}
                                              onChange={() =>
                                                handleToggleSelection(item)
                                              }
                                            />

                                            <ListItemButton
                                              sx={{
                                                pl: 2,
                                                bgcolor: selectedAreaNames.has(
                                                  item.area_name
                                                )
                                                  ? "rgba(0,200,0,0.1)"
                                                  : hasDescendantSelected(
                                                      item.area_code
                                                    )
                                                  ? "rgba(0,0,0,0.05)"
                                                  : "inherit",
                                              }}
                                              onClick={() =>
                                                handleToggleSelection(item)
                                              }
                                              dense={true}
                                            >
                                              <ListItemText
                                                primary={item.area_name}
                                              />
                                            </ListItemButton>
                                          </div>
                                          {/* Council */}
                                          <Collapse
                                            in={openRegion === item.area_code}
                                            timeout="auto"
                                            unmountOnExit
                                          >
                                            <div className="flex flex-row font-bold items-center ml-10">
                                              <Checkbox
                                                checked={getFilteredCouncilsToSelect(
                                                  Disctrict,
                                                  Council,
                                                  item.area_code
                                                ).every((council) =>
                                                  selectedAreaNames.has(
                                                    council.area_name
                                                  )
                                                )}
                                                indeterminate={
                                                  getFilteredCouncilsToSelect(
                                                    Disctrict,
                                                    Council,
                                                    item.area_code
                                                  ).some((council) =>
                                                    selectedAreaNames.has(
                                                      council.area_name
                                                    )
                                                  ) &&
                                                  !getFilteredCouncilsToSelect(
                                                    Disctrict,
                                                    Council,
                                                    item.area_code
                                                  ).every((council) =>
                                                    selectedAreaNames.has(
                                                      council.area_name
                                                    )
                                                  )
                                                }
                                                onChange={() =>
                                                  handleSelectAll(
                                                    "council",
                                                    item.area_code,
                                                    getFilteredCouncilsToSelect(
                                                      Disctrict,
                                                      Council,
                                                      item.area_code
                                                    )
                                                  )
                                                }
                                              />
                                              <span>Select All Councils</span>
                                            </div>

                                            <List component="div">
                                              {getFilteredCouncils(
                                                Disctrict,
                                                Council,
                                                openRegion
                                              ).map((item) => (
                                                <ListItem
                                                  key={item.area_code}
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "start",
                                                    alignItems: "start",
                                                  }}
                                                >
                                                  <div className="flex flex-row items-center">
                                                    {openCouncil ===
                                                    item.area_code ? (
                                                      <RemoveIcon
                                                        className="border mr-1"
                                                        fontSize="small"
                                                        onClick={() =>
                                                          handleClickCouncil(
                                                            item.area_code,
                                                            item.area_name
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      <AddIcon
                                                        className="border mr-1"
                                                        fontSize="small"
                                                        onClick={() =>
                                                          handleClickCouncil(
                                                            item.area_code,
                                                            item.area_name
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <Checkbox
                                                      checked={selectedAreaNames.has(
                                                        item.area_name
                                                      )}
                                                      onChange={() =>
                                                        handleToggleSelection(
                                                          item
                                                        )
                                                      }
                                                    />

                                                    <ListItemButton
                                                      sx={{
                                                        pl: 2,
                                                        bgcolor:
                                                          selectedAreaNames.has(
                                                            item.area_name
                                                          )
                                                            ? "rgba(0,200,0,0.1)"
                                                            : hasDescendantSelected(
                                                                item.area_code
                                                              )
                                                            ? "rgba(0,0,0,0.05)"
                                                            : "inherit",
                                                      }}
                                                      onClick={() =>
                                                        handleToggleSelection(
                                                          item
                                                        )
                                                      }
                                                      dense={true}
                                                    >
                                                      <ListItemText
                                                        primary={item.area_name}
                                                      />
                                                    </ListItemButton>
                                                  </div>
                                                  {/* wards */}
                                                  <Collapse
                                                    in={
                                                      openCouncil ===
                                                      item.area_code
                                                    }
                                                    timeout="auto"
                                                    unmountOnExit
                                                  >
                                                    <div className="flex flex-row items-center font-bold ml-6">
                                                      <Checkbox
                                                        checked={Ward.filter(
                                                          (ward) =>
                                                            belongsToParent(
                                                              ward.parent_code,
                                                              item.area_code
                                                            )
                                                        ).every((ward) =>
                                                          selectedAreaNames.has(
                                                            ward.area_name
                                                          )
                                                        )}
                                                        indeterminate={
                                                          Ward.filter((ward) =>
                                                            belongsToParent(
                                                              ward.parent_code,
                                                              item.area_code
                                                            )
                                                          ).some((ward) =>
                                                            selectedAreaNames.has(
                                                              ward.area_name
                                                            )
                                                          ) &&
                                                          !Ward.filter((ward) =>
                                                            belongsToParent(
                                                              ward.parent_code,
                                                              item.area_code
                                                            )
                                                          ).every((ward) =>
                                                            selectedAreaNames.has(
                                                              ward.area_name
                                                            )
                                                          )
                                                        }
                                                        onChange={() =>
                                                          handleSelectAll(
                                                            "ward",
                                                            item.area_code,
                                                            Ward.filter(
                                                              (ward) =>
                                                                belongsToParent(
                                                                  ward.parent_code,
                                                                  item.area_code
                                                                )
                                                            )
                                                          )
                                                        }
                                                      />
                                                      <span>
                                                        Select All Wards
                                                      </span>
                                                    </div>

                                                    <List component="div">
                                                      {Ward.map(
                                                        (item) =>
                                                          openCouncil ===
                                                            item.grandpa_code && (
                                                            <ListItem
                                                              key={
                                                                item.area_code
                                                              }
                                                              sx={{
                                                                display: "flex",
                                                                flexDirection:
                                                                  "column",
                                                                justifyContent:
                                                                  "start",
                                                                alignItems:
                                                                  "start",
                                                              }}
                                                            >
                                                              <div className="flex flex-row items-center">
                                                                <Checkbox
                                                                  checked={selectedAreaNames.has(
                                                                    item.area_name
                                                                  )}
                                                                  onChange={() =>
                                                                    handleToggleSelection(
                                                                      item
                                                                    )
                                                                  }
                                                                />

                                                                <ListItemButton
                                                                  sx={{
                                                                    pl: 2,
                                                                  }}
                                                                  onClick={() =>
                                                                    handleToggleSelection(
                                                                      item
                                                                    )
                                                                  }
                                                                  dense={true}
                                                                >
                                                                  <ListItemText
                                                                    primary={
                                                                      item.area_name
                                                                    }
                                                                  />
                                                                </ListItemButton>
                                                              </div>
                                                            </ListItem>
                                                          )
                                                      )}
                                                    </List>
                                                  </Collapse>
                                                </ListItem>
                                              ))}
                                            </List>
                                          </Collapse>
                                        </ListItem>
                                      )
                                  )}
                                </List>
                              </Collapse>
                            </ListItem>
                          )
                      )}
                    </List>
                  </Collapse>
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CensusAreaDropDown;
